import './OnlineUsers.scss';

import CIcon from '@coreui/icons-react';
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react';
import { IPageViewUser } from '@transferz/fe-models';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useUserMeQuery } from '../../hooks/useUserQuery';
import { useLazyQueryPageViews } from '../../queries/log/hooks/useLazyQueryPageViews';
import { useMutationRecordPageView } from '../../queries/log/hooks/useMutationRecordPageView';

interface IOnlineUsersProps {
    setDropdownOpen: (isDropdownOpen: boolean) => void;
}

export const OnLineUsers: React.FunctionComponent<IOnlineUsersProps> = ({ setDropdownOpen }) => {
  const { data } = useUserMeQuery();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [recordPageView] = useMutationRecordPageView();
  const [getPageViews] = useLazyQueryPageViews();
  const [onlineUsers, setOnlineUsers] = useState<IPageViewUser[]>([]);

  let fetchInterval = useRef<number | null>(-1);
  let postInterval = useRef<number | null>(-1);

  const location = useLocation();

  const updatePageView = async () => {
    recordPageView({ variables: {
      params: {
        application: 'backoffice',
        page: `${location.pathname}${location.search}`,
      },
    } });
  };

  const fetchPageViews = async () => {
    getPageViews({
      variables: {
        params: {
          application: 'backoffice',
          page: `${location.pathname}${location.search}`,
          timeFrameInSeconds: 60,
        },
      },
      fetchPolicy: 'no-cache',
    })
      .then((response: any) => {
        setOnlineUsers(response.data.pageViews.filter((user: IPageViewUser) => user.userName !== data?.me?.name));
      });
  };

  useEffect(() => {
    if (fetchInterval.current) {
      clearInterval(fetchInterval.current);
    }
    if (postInterval.current) {
      clearInterval(postInterval.current);
    }
    updatePageView();
    fetchPageViews();
    fetchInterval.current = window.setInterval(() => {
      fetchPageViews();
    }, 10000);
    postInterval.current = window.setInterval(() => {
      updatePageView();
    }, 55000);
  }, [location]);

  useEffect(() => {
    if (dropdownRef.current) {
      const observer = new MutationObserver(() => setDropdownOpen(!!dropdownRef.current?.classList.contains('show')));
      observer.observe(dropdownRef.current, {
        attributes: true,
        characterData: false,
        childList: false,
        subtree: false,
      });
      return () => observer.disconnect();
    }
  }, [dropdownRef.current]);

  useEffect(() => {
    if (data?.me?.name) {
      const users = onlineUsers;
      setOnlineUsers(users.filter((user: IPageViewUser) => user.userName !== data?.me?.name));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      const users = onlineUsers;
      setOnlineUsers(users.filter((user: IPageViewUser) => user.userName !== data?.me?.name));
    }
  }, [data]);

  return (
    <CDropdown inNav className="c-header-nav-items mx-2 online-users" innerRef={dropdownRef}>
      <CDropdownToggle className="c-header-nav-link" caret={false} >
        <div className="menu-container">
          <CIcon name="cil-people" className="mfe-2 online-icon" width={20} />
          {onlineUsers.length ? <div className="menu-container-counter">
            {onlineUsers.length}
          </div> : <></> }
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end" >
        {onlineUsers.length ? <CDropdownItem className="menu-container-title">
          Users viewing this page
        </CDropdownItem> : <CDropdownItem className="menu-container-title">
          No users are viewing this page
        </CDropdownItem>}
        { onlineUsers.map((user: IPageViewUser, index: number) => (
          <CDropdownItem key={index}>
            {user.userName}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  );
};
